<template>
  <div class="container">
    <head-nav-bar title="我的账单" :fixed="true" @click-left="back" />
    <div class="list mt-header-nav">
      <ContactCard v-model="contact" @change="onContactChange" />
      <div class="kong"></div>
      <van-tabs
        v-model="tabActive"
        @click="onClick"
        sticky
        :offset-top="46"
        style="width:100%;"
      >
        <van-tab title="待支付">
          <DataList
            api="Bill_List"
            :params="listParams1"
            :onAutoLoad="!lsOnLoat"
          >
            <template v-slot:item="item">
              <van-cell is-link @click="toInfo(item.obj, 0)">
                <div slot="title">
                  <div>
                    {{ item.obj.departmentName }}
                    <span style="margin-left:0.5rem;"
                      >{{ item.obj.chargeType }}
                    </span>
                  </div>
                  <div class="text-less" style="font-size:0.35rem;">
                    {{ item.obj.visitDate }}
                  </div>
                </div>
                <div class="value">
                  {{ item.obj.amount }}
                </div>

                <van-icon
                  slot="right-icon"
                  name="arrow"
                  style="line-height: 1.3rem;"
                />
              </van-cell>
            </template>
          </DataList>
        </van-tab>
        <van-tab title="已支付">
          <DataList
            api="Bill_List"
            :params="listParams2"
            :onAutoLoad="lsOnLoat"
          >
            <template v-slot:item="item">
              <van-cell is-link @click="toInfo(item.obj, 1)">
                <div slot="title">
                  <div>
                    {{ item.obj.departmentName }}
                    <span style="margin-left:0.5rem;"
                      >{{ item.obj.chargeType }}
                    </span>
                  </div>
                  <div class="text-less" style="font-size:0.35rem;">
                    {{ item.obj.visitDate }}
                  </div>
                </div>
                <div class="value">
                  {{ item.obj.amount }}
                </div>

                <van-icon
                  slot="right-icon"
                  name="arrow"
                  style="line-height: 1.3rem;"
                />
              </van-cell>
            </template>
          </DataList>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import { List, Tag, Button, Icon, Cell, Tab, Tabs } from "vant";
import DataList from "@/components/DataList";
import ContactCard from "@/components/ContactCard";
import { cache } from "@/utils/common";

export default {
  name: "userBillList",
  components: {
    DataList,
    ContactCard,
    [List.name]: List,
    [Tag.name]: Tag,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs
  },
  data() {
    return {
      contact: {},
      list: [],
      loading: false,
      finished: false,
      tabActive: 0,
      listParams1: {},
      listParams2: {},
      lsOnLoat: false
    };
  },
  watch: {
    contact(contact) {
      setTimeout(() => {
        this.listParams1 = {
          DiagnosisCardNo: contact.diagnosisCardNo,
          PayStatus: 0
        };
        this.listParams2 = {
          DiagnosisCardNo: contact.diagnosisCardNo,
          PayStatus: 1
        };
      }, 100);
    }
  },
  created() {
    const query = this.$route.query;
    if (query && query.tab == 1) {
      this.tabActive = 1;
      this.lsOnLoat = true;
    }
    if (query && query.id) {
      cache.set("currentContact", query);
    }
  },
  methods: {
    onClick(name) {
      if (name == 0) {
        this.listParams1 = {
          DiagnosisCardNo: this.contact.diagnosisCardNo,
          PayStatus: 0,
          PageIndex: 0
        };
      } else {
        this.listParams2 = {
          DiagnosisCardNo: this.contact.diagnosisCardNo,
          PayStatus: 1,
          PageIndex: 0
        };
      }
    },
    back() {
      this.$router.push({
        name: "userIndex"
      });
    },
    toInfo(item, type) {
      item.payStatus = this.tabActive;
      item.diagnosisCardNo = this.contact.diagnosisCardNo;
      item.type = type;
      this.$router.push({
        name: "userBillInfo",
        query: item
      });
    },
    //切换就诊人
    onContactChange() {
      this.listParams1 = {
        DiagnosisCardNo: this.contact.diagnosisCardNo,
        PayStatus: 0
      };
      this.listParams2 = {
        DiagnosisCardNo: this.contact.diagnosisCardNo,
        PayStatus: 1
      };
    }
  }
};
</script>

<style lang="less" scoped>
.list-item {
  .value {
    line-height: 1.3rem;
    color: #333;
    font-size: 0.5rem;
  }
}
</style>
